import React from "react";

const KYCICON = ({
  width = 46,
  height = 46,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="44" height="44" rx="22" fill="#133345" />
      <rect x="1" y="1" width="44" height="44" rx="22" stroke="#E2E4E9" />
      <path
        d="M24.8008 25.0284V26.9094C23.9862 26.6214 23.1144 26.533 22.2586 26.6518C21.4029 26.7705 20.5881 27.0929 19.8827 27.5917C19.1773 28.0906 18.6019 28.7515 18.2048 29.5188C17.8078 30.2862 17.6006 31.1376 17.6008 32.0016L15.8008 32.0007C15.8005 30.9017 16.0518 29.8172 16.5355 28.8303C17.0191 27.8435 17.7222 26.9804 18.591 26.3073C19.4597 25.6342 20.471 25.1689 21.5474 24.947C22.6238 24.7252 23.7367 24.7527 24.8008 25.0275V25.0284ZM23.0008 23.9016C20.0173 23.9016 17.6008 21.4851 17.6008 18.5016C17.6008 15.5181 20.0173 13.1016 23.0008 13.1016C25.9843 13.1016 28.4008 15.5181 28.4008 18.5016C28.4008 21.4851 25.9843 23.9016 23.0008 23.9016ZM23.0008 22.1016C24.9898 22.1016 26.6008 20.4906 26.6008 18.5016C26.6008 16.5126 24.9898 14.9016 23.0008 14.9016C21.0118 14.9016 19.4008 16.5126 19.4008 18.5016C19.4008 20.4906 21.0118 22.1016 23.0008 22.1016ZM29.677 27.5016H32.9044V29.3016H29.677L31.3231 30.9468L30.0505 32.2203L26.2318 28.4016L30.0505 24.5829L31.3231 25.8564L29.677 27.5016Z"
        fill="white"
      />
    </svg>
  );
};

export default KYCICON;
